export const INITIAL_FORM_SES = (userID: number | string) => ({
  cnes: '',
  usuarioId: userID,
});

export const INITIAL_FORM_SES_FICHA = (
  userID: number | string,
  form: any | undefined,
) => ({
  id: 0,
  usuarioId: userID,
  cnes: form?.cnes ?? 0,
  nome: '',
  nomeEmpresarial: '',
  dependencia: '',
  regionalSaude: '',
  tipoEstabelecimento: '',
  subtipoEstabelecimento: '',
  gestao: '',
  telefone1: '',
  telefone2: '',
  email: '',
  site: '',
  cep: '',
  bairro: '',
  logradouro: '',
  complemento: '',
  numeroImovel: '',
  observacoes: '',

  municipioIbgeId: 0,
  ufSigla: '',
  municipio: '',
  naturezaJuridicaId: 2,
  descNaturezaJuridica: '',
});

export const INITIAL_LOG_DATA_SES = {
  id: '',
  usuarioRegistro: {
    nomeCompleto: '',
  },
  usuarioAtualizacao: {
    nomeCompleto: '',
  },
  dataRegistro: '',
  dataUltimaAtualizacao: '',
  dataUltimaVisualizacao: '',
  nEdicoes: '',
  nVisualizacoes: '',
  nVisualizadores: '',
};
